<template>
    <div>

        <v-form ref="formDatosProgramar" lazy-validation>
            <v-row>
                <v-col cols="12" md="4" lg="4">
                    <textfieldComp @blur="validarCampo" :rules="validationRules.validateCampo"
                        textLabel="Nombre de la la evaluación" type="text" v-model="datosEval.nombre_evaluacion" />
                </v-col>
                <v-col cols="12" md="4" lg="4">
                    <AutocompleteComp textLabel="Forma de evaluación" v-model="datosEval.id_forma_evaluacion"
                        :items="listForma" item-value="id" item-text="desc_forma" :isDisable="evento == 'editar'"
                        @change="cambiarFormaEval(datosEval.id_forma_evaluacion)"
                        :rules="validationRules.validateCampo" />
                </v-col>
                <v-col cols="6" md="4" lg="4">
                    <AutocompleteComp :dense="true" textLabel="Tipo de evaluación"
                        v-model="datosEval.id_tipo_evaluacion" :items="listTipo" item-value="id" item-text="desc_tipo"
                        :isDisable="evento == 'editar'" :rules="validationRules.validateCampo" />
                </v-col>
                <!-- v-if="datosEval.tipo_calificacion == 'L'" -->
                <v-col cols="6" md="2" lg="2">
                    <AutocompleteComp textLabel="Calificación máxima" v-model="datosEval.id_calificacion_evaluacion"
                        :items="listCalificacionEvaluacion" item-value="id" item-text="calificacion"
                        :isDisable="evento == 'editar'" :rules="validationRules.validateCampo" />
                </v-col>
                <v-col v-if="datosEval.tipo_calificacion == 'N'" cols="6" md="3" lg="3">
                    <v-text-field @blur="validarCampo" v-if="datosEval.tipo_calificacion == 'N'" label="Calificacion"
                        type="number" v-model="datosEval.id_calificacion_evaluacion"
                        :rules="validationRules.validateCampo" :min="1" :max="20" set="1">
                    </v-text-field>
                </v-col>
                <v-col cols="6" md="4" lg="4">
                    <v-menu v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y
                        max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="datosEval.fecha_informat" :rules="validationRules.validateCampo"
                                label="Fecha" readonly v-on="on" :disabled="inhabilitarFecha">
                            </v-text-field>
                        </template>
                        <v-date-picker v-model="datosEval.fecha_informat" :min="getEndDate" no-title
                            @input="menu2 = false" :allowed-dates="allowedDates"></v-date-picker>
                    </v-menu>
                    <!-- :min="getEndDate" allowedDays -->
                </v-col>
                <v-col cols="6" md="2" lg="2">
                    <v-text-field @blur="validarCampo" ref="refHoraInicio" v-model="datosEval.hora_inicio"
                        label="Hora inicio" :rules="validationRules.validateCampo" :disabled="inhabilitarHoraInicio"
                        type="time" min="00:01" max="23:59" step="1"></v-text-field>
                </v-col>
                <v-col cols="2" md="2" lg="2">
                    <v-text-field @blur="validarCampo" ref="refHoraFin" v-model="datosEval.hora_fin" label="Hora fin"
                        :disabled="true" type="time" min="00:01" max="23:59" step="1"
                      ></v-text-field> 
                <!-- inhabilitarHoraFin :rules="[validarHorasEval]"-->
                </v-col>
                <v-col cols="12" md="2" lg="2">
                    <v-text-field @blur="validarCampo" label="Duración (minutos)" type="number" v-model="duracion_eval"
                        :rules="validationRules.validateCampo"></v-text-field> 
                </v-col>
                <v-col cols="12" md="4" lg="4">
                    <textfieldComp textLabel="Objetivo de la evaluación" type="text"
                        :rules="validationRules.validateCampo" v-model="datosEval.objetivo_evaluacion" />
                </v-col>
                <!-- <pre>Inicio del pre :  {{ datosEval }} </pre> -->
                <v-col cols="12" md="8" lg="8">
                    <!-- :rules="validationRules.validateCampo" -->
                    <v-textarea @blur="validarCampo" label="Observación" v-model="datosEval.observacion_evaluacion"
                        rows="1" :disabled="inhabilitarObservacion">
                    </v-textarea>
                </v-col>
            </v-row>
            <v-card-actions>
                <v-tooltip right color="#1b1b1b">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" @click="refresh();" icon color="green">
                            <v-icon>fas fa-sync</v-icon>
                        </v-btn>
                    </template>
                    <span>Limpiar campos</span>
                </v-tooltip>
                <v-spacer />
                <!-- v-if="this.evento == 'add'" <TableButtonComp normalButton v-if="this.evento == 'edit'" @click="saveItem();" textButton="Guardar cambios" iconBut="fas fa-save"/> fas fa-arrow-right-->
                <TableButtonComp v-if="parametros.evento == 'add'" :classButton="'mr-2'" normalButton
                    @click="backParent" textButton="Anterior" iconBut="fas fa-arrow-left" />
                <TableButtonComp normalButton @click="nextStep()" textButton="Siguiente" iconBut="" />
            </v-card-actions>
        </v-form>
    </div>
</template>
<script>
import axios from '@/helpers/axios'
import moment from 'moment';
import { mapMutations, mapGetters, mapActions, mapState } from 'vuex'
import { validationRules } from '../../../../../helpers/validatorHelpers';
import AutocompleteComp from '../../../../../components/ComponentsEst/AutocompleteComp.vue'
import textfieldComp from '../../../../../components/ComponentsEst/textfieldComp.vue'
import TableButtonComp from '../../../../../components/ComponentsEst/TableButtonComp.vue'

export default {
    name: "evaluacionInformacion",
    props: {
        parametros: {
            type: Object
        },
        estadoComp: {
            type: Boolean
        },
        estadoValidacion: {
            type: Boolean
        },
        wizardChange: {
            type: Number
        }
    },
    components: {
        AutocompleteComp,
        textfieldComp,
        TableButtonComp,
    },
    data: () => ({
        // paramComponente: { "id_modulo": 8, 'id_submodulo': 96 },
        datoLogin: sessionStorage,
        listForma: [],
        listTipo: [],
        listCalificacionEvaluacion: [],
        horaActualReloj: '',
        datosEval: {
            // objetivo_evaluacion:''
        },
        // objetivo_evaluacion:'',
        inhabilitarFecha: false,
        inhabilitarHoraInicio: false,
        inhabilitarHoraFin: false,
        inhabilitarObservacion: false,
        evento: null,
        menu2: false,
        // allowedDaysR: [],
        progData: [],

        duracion_eval: 0
    }),

    mounted() {
        this.loadMain()
        // this.$store.dispatch('getAlldiasEscolares').then(() => {
        //     this.allowedDaysR = this.diasEscolaresColegio;
        // })
    },
    computed: {
        ...mapGetters({
            componenteEvento: 'login/componenteEvento', // this.actualizarParamentro()
            formValidados: 'gestEvaluacion/formValidados',
        }),
        ...mapState({
            // diasEscolaresColegio: state => state.diasEscolaresColegio,
            horariosDiasDisponibles: state => state.progDocente.horariosDiasDisponibles,
        }),
        validationRules() {
            return validationRules;
        },
        // Maxima Fecha Calendario fecha actual
        getEndDate() {
            return moment().format('YYYY-MM-DD')
        },  
        // minSelectableDate() {
            // const today = new Date();
            // today.setDate(today.getDate() - 0); // Resta un día para bloquear fechas anteriores
            // return today.toISOString().substr(0, 10); // Fecha mínima (hoy - 1 día)
        // },
    },
    watch: {
        estadoComp(flag) { //OBSERVA EL CAMBIO DE ESTADO DEL COMPONENTE
            if (flag) {
                this.loadMain();
            } else {
                this.refresh();
            }
        },
        estadoValidacion(flag) { //OBSERVA EL CAMBIO DE ESTADO DEL FORMULARIO
            if (flag) {
                this.validarCampoReal();
            }
        },
        wizardChange(step) { //OBSERVA EL CAMBIO DE STEPPER
            // this.validarCampoReal(); 
            if (step == 1) {
                this.$refs.formDatosProgramar.resetValidation();
                this.datosEval.periodo = parseInt(this.datoLogin.id_ano_lectivo, 10);
                this.datosEval.id_usuario = parseInt(this.datoLogin.id, 10);
                this.datosEval.duracion_evaluacion = parseInt(this.duracion_eval);
                this.datosEval.id_colegio = parseInt(this.datoLogin.id_colegio, 10);
                this.datosEval.fecha = this.datosEval.fecha_informat != "" && this.datosEval.fecha_informat != undefined ? new Date(this.datosEval.fecha_informat).toISOString() : "";
                this.datosEval.id_us_ing = parseInt(this.datoLogin.id, 10);
                this.datosEval.fec_usu_ing = new Date(Date.now()).toISOString() || null;
                this.setFormEval(this.datosEval);
            }
        },
    },
    methods: {
        ...mapMutations({
            setEnviarMens: "mensajeSis/setEnviarMens",
            setFormEval: "gestEvaluacion/setFormEval"
        }),

        ...mapActions({
            parametroComponente: "login/parametroComponente",
            validateForm: "gestEvaluacion/validateForm",
            obtenerHorariosDocente: "progDocente/obtenerHorariosDocente"
        }),
        /** 
         __________________________
        |  MÉTODO CARGAR INICIAL */
        async loadMain() {
            this.getModalidadEval();
            this.getTipo();

            await this.obtenerHorariosDocente({
            id_personal:this.parametros.evento == 'add'? this.parametros.items.id_docente:this.parametros.items.id_profesor,
            id_seccion:this.parametros.items.id_seccion, 
            id_curso:this.parametros.items.id_curso})

            switch (this.parametros.evento) {

                case 'add':
                    this.addItem();
                    // this.refresh();
                    break;

                case 'edit':
                    this.editItem();
                    break;

            }

            this.getEscalaEvaluativa()
        },
        /** 
         ________________________________________
        |  MÉTODO VALIDAR DURACION A FIN HORAS */
        // validaFechaFin() {

        //     const [horasInicio, minutosInicio] = this.datosEval.hora_inicio.split(':').map(Number);
        //     const minutosTotalesInicio = horasInicio * 60 + minutosInicio;
        //     // Sumar this.duracion a minutosTotalesInicio
        //     const minutosTotalesFin = minutosTotalesInicio + Number(this.duracion_eval);
        //     // Convertir minutosTotalesFin de vuelta a formato de horas y minutos
        //     const horasFin = Math.floor(minutosTotalesFin / 60);
        //     const minutosFin = minutosTotalesFin % 60;

        //     // Formatear horasFin y minutosFin para asegurarse de que estén en formato HH:MM
        //     const horasFinStr = horasFin.toString().padStart(2, '0');
        //     const minutosFinStr = minutosFin.toString().padStart(2, '0');

        //     // Asignar el resultado a this.fecha_fin
        //     this.datosEval.hora_fin = horasFinStr + ':' + minutosFinStr;

        // },
        /** 
         ____________________________________
        |  MÉTODO VALIDAR HORAS Y DURACION */
        // validarHorasEval() {
        //     let diferencia = '';

        //     if (this.datosEval.hora_inicio && this.datosEval.hora_fin) {
        //         const [horasInicio, minutosInicio] = this.datosEval.hora_inicio.split(':').map(Number);
        //         const [horasFin, minutosFin] = this.datosEval.hora_fin.split(':').map(Number);
        //         const minutosTotalesInicio = horasInicio * 60 + minutosInicio;
        //         const minutosTotalesFin = horasFin * 60 + minutosFin;

        //         diferencia = minutosTotalesFin - minutosTotalesInicio;
        //         this.duracion_eval = diferencia;

        //         if (diferencia < 0) {
        //             this.duracion_eval = 0;
        //         }
        //         return minutosTotalesFin > minutosTotalesInicio || "La hora fin debe ser mayor a la hora inicio";
        //     }
        //     this.duracion_eval = diferencia;
        //     return true;
        // },
        /** 
         ___________________________
        |  MÉTODO VALIDAR CAMPOS  */
        validarCampoReal() {
            const isValid = this.$refs.formDatosProgramar.validate(false);
            this.validateForm({ index: 0, value: isValid });
        },
        validarCampo() {
            const isValid = this.$refs.formDatosProgramar.validate(false);
            if (isValid) {
                this.validateForm({ index: 0, value: isValid });
            }
        },
        /** 
         _________________________________________
        |  MÉTODO OBTENER FORMAS DE EVALUACION  */
        async getModalidadEval() {
            try {
                const response = await axios.get(`/evaluacion/forma/`)
                this.listForma = response.data;
            } catch (error) {
                console.log(error)
            }
        },
        /** 
         ________________________________________
        |  MÉTODO OBTENER TIPOS DE EVALUACION  */
        async getTipo() {

            try {
                const response = await axios.get(`/evaluacion/tipo/`)
                this.listTipo = response.data

            } catch (error) {
                console.log(error)
            }
        },
        /** 
         _________________________________________
        |  MÉTODO OBTENER ESCALA DE EVALUACION  */
        async getEscalaEvaluativa() {
            try {
                let params = {
                    id_colegio: this.datosEval.id_colegio, id_ano_lectivo: this.datosEval.id_ano_lectivo,
                    id_nivel: this.datosEval.id_nivel, id_grado: this.datosEval.id_grado
                }

                let response = await axios.post(`/evaluacion/programacion/escalaEvaluativaGrado/`, { filter: params })
                if (response.data.escalaEvaluacion.length == 0) {
                    this.setEnviarMens({ tipo: "E", mensaje: `No se configuro la escala evaluativa para el grado`, tiempo: 6000 })
                    return false
                }

                this.datosEval.tipo_calificacion = response.data.escalaEvaluacion[0].tipo_escala
                this.datosEval.id_periodo = response.data.escalaEvaluacion[0].id_periodo
                this.listCalificacionEvaluacion = response.data.notaEvaluacion

                // Ingresar Parametro Fijo para tipo calificacion Literal                
                if (this.parametros.items.tipo_calificacion == "L") {
                    let notaMaxima = Math.max(...this.listCalificacionEvaluacion.map(item => item.nota_max))
                    let calificacion = this.listCalificacionEvaluacion.find(e => e.nota_max === notaMaxima)
                    this.datosEval.id_calificacion_evaluacion = calificacion.id
                }

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }
        },
        /** 
         _________________________________________
        |  MÉTODO CAMBIAR FORMAR DE EVALUACION  */
        cambiarFormaEval(valor) {
            this.setEnviarMens({ tipo: "W", mensaje: `Forma de evaluación seleccionada: ${valor}`, tiempo: null })
        },
        /** 
         ____________________
        |  MÉTODO ADD ITEM */
        addItem() {
            this.$refs.formDatosProgramar.resetValidation()
            this.datosEval.titulo = "Crear"
            this.evento = this.parametros.evento
            this.datosEval = this.parametros.items  // ojo no activar monta el estado 4 de programacion ejecutada
            this.datosEval.id_estado = 1
            this.datosEval.id_nivel = this.parametros.items.id_nivel
            this.datosEval.id_grado = this.parametros.items.id_grado
            this.datosEval.id_seccion = this.parametros.items.id_seccion
            this.datosEval.id_area = this.parametros.items.id_area
            this.datosEval.id_curso = this.parametros.items.id_curso
            this.datosEval.id_programacion = this.parametros.items.id_programacion
            this.datosEval.id_profesor = this.parametros.items.id_docente
            this.datosEval.hora_fin = '23:59'
            this.datosEval.duracion_evaluacion = 0
            // this.datosEval.observacion_evaluacion = ""


        },
        editItem() {
            this.evento = this.parametros.evento;
            this.datosEval = this.parametros.items;
            this.datosEval.fecha_informat = this.parametros.items.fecha;
            this.duracion_eval = this.parametros.items.duracion_evaluacion;
            // this.inhabilitarFecha = true
        },
        /** 
         ________________________________
        |  MÉTODO EMIT SIGUIENTE PASO  */
        nextStep() {
            this.$refs.formDatosProgramar.resetValidation();
            this.datosEval.periodo = parseInt(this.datoLogin.id_ano_lectivo, 10);
            this.datosEval.id_usuario = parseInt(this.datoLogin.id, 10);
            this.datosEval.id_colegio = parseInt(this.datoLogin.id_colegio, 10);
            this.datosEval.duracion_evaluacion = parseInt(this.duracion_eval);
            // this.datosEval.fecha = this.datosEval.fecha_informat != null ? new Date(this.datosEval.fecha_informat).toISOString() : null;
            this.datosEval.fecha = this.datosEval.fecha_informat != "" && this.datosEval.fecha_informat != undefined ? new Date(this.datosEval.fecha_informat).toISOString() : "";
            this.datosEval.id_us_ing = parseInt(this.datoLogin.id, 10);
            this.datosEval.fec_usu_ing = new Date(Date.now()).toISOString() || null;
            this.setFormEval(this.datosEval);
            this.$emit('wizardNext', 1);
        },

        /** 
         ________________________
        |  MÉTODO LIMPIAR FORM */
        limpiarForm() {
            this.datosEval = {
                id: -1,
                id_usuario: this.datoLogin.id,
                id_colegio: this.datoLogin.id_colegio,
                id_ano_lectivo: this.datoLogin.id_ano_lectivo,
                id_periodo: -1,
                id_nivel: -1,
                id_grado: -1,
                id_area: -1,
                id_curso: -1,
                id_seccion: -1,
                id_programacion: -1,
                id_profesor: -1,
                id_forma_evaluacion: -1,
                id_tipo_evaluacion: -1,
                id_calificacion_evaluacion: -1,
                tipo_calificacion: "",
                nombre_evaluacion: "",
                objetivo_evaluacion: "",
                fecha: "",
                hora_inicio: "",
                hora_fin: "",
                duracion: "",
                observacion_evaluacion: "",
                id_estado: 1
            }
            // inhabilitar campos de porgramacion docente Agregar o editar
            this.inhabilitarFecha = false
            this.inhabilitarHoraInicio = false
            this.inhabilitarHoraFin = false
            this.inhabilitarObservacion = false
            this.$refs.formDatosProgramar.resetValidation()
        },
        /** 
         ________________________________
        |  MÉTODO RESETEAR CAMPOS FORM */
        refresh() {

            this.$refs.formDatosProgramar.resetValidation()
            this.datosEval.nombre_evaluacion = "";
            this.datosEval.id_forma_evaluacion = "";
            this.datosEval.id_tipo_evaluacion = "";
            this.datosEval.id_calificacion_evaluacion = "";
            this.datosEval.fecha_informat = "";
            this.datosEval.hora_inicio = "";
            this.datosEval.hora_fin = "23:59";
            this.duracion_eval = 0
            this.datosEval.duracion_evaluacion = this.duracion_eval;
            this.datosEval.objetivo_evaluacion = "";
            this.datosEval.observacion_evaluacion = "";
            this.validateForm({ index: 0, value: true });
        },
        /** 
         ___________________________
        |  MÉTODO DIAS PERMITIDOS */
        // allowedDays: function (date) {
        //     return this.allowedDaysR.includes(date);
        // },
            /** 
         ____________________________________________
        |          MÉTODO DIAS PERMITIDOS          */
        allowedDates(val){      
            const dateParts = val.split('-');
            const selectedDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
            const dayOfWeek = selectedDate.getDay();
            return this.horariosDiasDisponibles.includes(dayOfWeek); 
        },
        /** 
         _____________________________
        |  MÉTODO REGRESAR STEPPER */
        backParent() {
            this.$emit('wizardNext', -1)
            // this.$refs.formDatosProgramar.resetValidation()
        },
    
    }
};
</script>
